import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentsSection, PageTitle } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { LoadingBox } from "component/basic/popup";
import { FixedPage, FixedSection } from "component/basic";
import { NotItems } from "component/basic/notItems";
import { PointFixedTap, Tap } from "component/basic/tap";
import { FixedContents } from "component/product/page";
import { AlarmList, MypageContentsBox, MypageControll, PageContentsSection } from "component/mypage/items";
import { bottomChk } from "js/function";

const Alarm = (props) => {
    const navigate = useNavigate();

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);
    const [alarmType,setAlarmType] =  useState(null);

    const [page,setPage] =  useState(1);
    const [itemList,setItemList] =  useState([]);

    let lastPage = false;
    let settingChk = 0;

    const pageDataApi = useGet({
        url:`/alarm?page=${page}${alarmType || alarmType == 0 ? `&status=${alarmType}` : ""}`,
        loginType:"login"
    });
    const pageData = pageDataApi?.data?.alarms;

    useEffect(() => {
        setItemList([]);
        setPage(1);
    }, [alarmType]);

    function addPage(){
        setLoadingBoxOpen(true);
        setPage(page + 1);
        settingChk = 1;
        setTimeout(() => {
            settingChk = 0;
        }, 300);
    };
    
    useEffect(() => {
        if(pageData?.data && pageData?.data.length > 0){
            if(page == 1){
                setItemList([...pageData?.data]);
            }else{    
                setItemList(prev => [...prev, ...pageData?.data]);
            }
        }else{
            setItemList([]);
        }

        lastPage = pageData?.current_page < pageData?.last_page;

        setLoadingBoxOpen(false);

        window.removeEventListener("scroll", handleScroll);
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [pageDataApi]);
    
    function handleScroll(){
        if(bottomChk() && lastPage && settingChk == 0){
            addPage();
        }
    };
    
    useEffect(() => {
        setItemList([]);
        const timer = setInterval(() => {
            window.addEventListener("scroll", handleScroll);
        }, 100);
        return () => {
            clearInterval(timer);
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        setLoadingBoxOpen(false);
    }, []);

    return (
        <>
            <ContentsSection
                header={true}
                footer={true}
                addClass={"gBg mTapContents"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={()=>{navigate(-1)}}
                    headTitle={"알림"}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={3}
                    closeFunc={()=>{}}
                />
                <FixedPage addClass="reverse mnReverse">
                    <FixedSection
                        pageBox="pageSizing"
                        boxAddClass="fixedsection_min pcItemT"
                        addClass="nonFixed fixedsection_min"
                        contentsBox="fixedPage"
                        nonFixed={true}
                        headerChk={true}
                        footerChk={true}
                        minSize={961}
                    >
                        <MypageControll
                            addClass="pcItemT"
                            data={null}
                        />
                    </FixedSection>
                    <FixedContents addClass="mypageFixedContents">
                        <PageTitle
                            addClass="fixedContents_title pcItemT"
                            pageBack={null}
                            contents="알림"
                        >
                            <Tap
                                addClass="underLine"
                                data={[
                                    {
                                        id:0,
                                        name:"안읽음"
                                    }
                                ]}
                                nameKey={"name"}
                                valKey={"id"}
                                nameCaption={null}
                                val={alarmType}
                                allText="전체"
                                func={(name,val)=>{setAlarmType(val)}}
                            />
                        </PageTitle>
                        <PointFixedTap
                            boxAddClass={"mItemT row"}
                            headerTap={true}
                            headerChk={true}
                            addClass=""

                            data={[
                                {
                                    id:0,
                                    name:"안읽음"
                                }
                            ]}
                            nameKey={"name"}
                            valKey={"id"}
                            nameCaption={null}
                            val={alarmType}
                            allText="전체"
                            func={(name,val)=>{setAlarmType(val)}}
                        />
                        <PageContentsSection addClass="">
                            {itemList && itemList?.length > 0 ? 
                                <MypageContentsBox
                                    nPadding={true}
                                    title={null}
                                >
                                    {itemList && itemList?.map((item, i) => (
                                        <AlarmList
                                            key={i}
                                            id={item?.id}
                                            title={item?.title}
                                            contents={item?.contents}
                                            link={item?.link}
                                            status={item?.status}
                                        />
                                    ))}
                                </MypageContentsBox>
                            :
                                <NotItems addClass="fullPage" text={`알림 내역이 없습니다.`}/>
                            }
                        </PageContentsSection>
                    </FixedContents>
                </FixedPage>
            </ContentsSection>
            <Footer/>
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default Alarm;